// Setup Vue
import { createApp } from 'vue'
window.Vue = createApp;

// Our extensions and components
import PasswordUser from './components/PasswordUser.vue';

var app = createApp({
    components: {
        'password-user': PasswordUser,
    },
    data() {
        return {
            user: user,
            userId: userId,
        }
    }
}).mount("#password-app");
